import { useDownload } from "@/hooks/use-download";
import { cn } from "@/utils/cn";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export function DownloadProgress() {
  const { tasks, removeTask } = useDownload();
  const { t } = useTranslation();

  const activeTasks = tasks.filter((t) => !t.done);
  const hasError = tasks.some((t) => !!t.error);
  const progress = activeTasks.length === 0
    ? 1
    : Math.max(0, Math.min(1, activeTasks.reduce((sum, t) => sum + (t.percent || 0), 0) / (activeTasks.length * 100)));
  const percent = Math.round(progress * 100);

  useEffect(() => {
    tasks.forEach((task) => {
      if (task.done) {
        removeTask(task.id);
      }
    });
  }, [tasks]);

  const label = hasError
    ? t("global_download.download_failed")
    : activeTasks.length === 0
      ? t("global_download.download_complete")
      : t("global_download.saving");

  return (
    <div className={cn("fixed inset-0 z-[1000] pointer-events-none", tasks.length === 0 ? "hidden" : "")}>
      <div className="absolute inset-0 bg-transparent pointer-events-auto" />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-[124px] h-[124px] rounded-2xl bg-black flex flex-col items-center justify-center">
          <div className="relative w-10 h-10">
            <svg className="w-10 h-10 -rotate-90" viewBox="0 0 40 40">
              <circle cx="20" cy="20" r="16" stroke="rgba(255,255,255,0.5)" strokeWidth="4" fill="none" />
              <circle cx="20" cy="20" r="16" stroke="#ffffff" strokeWidth="4" fill="none" strokeLinecap="round" strokeDasharray={`${2 * Math.PI * 16}`} strokeDashoffset={`${2 * Math.PI * 16 * (1 - progress)}`} className="transition-all duration-250 ease-out" />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-white text-xs font-medium">{percent}%</span>
            </div>
          </div>
          <div className="mt-2 text-white text-xs font-medium">{label}</div>
        </div>
      </div>
    </div>
  );
}
